/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0ubfYRlfZc%20button%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D%0A._0RxVZVy7kJ%20button%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D%0A._46PhP8f7mX%20button%7Bfont-weight%3Avar(--ds-font-weight-medium%2C500)%7D%0A._0rushMd1Zr%20button%3Ahover%7Bbackground-color%3Avar(--ds-surface-hovered%2C%23f0f1f2)%7D%0A._0jh4YZy7kJ%20button%3Ahover%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D%0A%40keyframes%20k1y7llxx%7B0%25%7Btransform%3Atranslate(-120%25%2C-25%25)%3Bopacity%3A0%3Banimation-timing-function%3Alinear%7D15%25%7Bopacity%3A1%3Btransform%3Atranslate(-70%25%2C-25%25)%3Banimation-timing-function%3Alinear%7D25%25%7Btransform%3Atranslate(-50%25%2C-10%25)%3Banimation-timing-function%3Alinear%7D33%25%7Btransform%3Atranslate(-32%25%2C8%25)%3Banimation-timing-function%3Alinear%7D42%25%7Btransform%3Atranslate(-15%25%2C22%25)%3Banimation-timing-function%3Alinear%7D50%25%7Btransform%3Atranslate(0%2C25%25)%3Banimation-timing-function%3Alinear%7D58%25%7Btransform%3Atranslate(15%25%2C22%25)%3Banimation-timing-function%3Alinear%7D67%25%7Btransform%3Atranslate(32%25%2C8%25)%3Banimation-timing-function%3Alinear%7D75%25%7Btransform%3Atranslate(50%25%2C-10%25)%3Banimation-timing-function%3Alinear%7D85%25%7Bopacity%3A1%3Btransform%3Atranslate(100%25%2C-25%25)%3Banimation-timing-function%3Alinear%7Dto%7Btransform%3Atranslate(120%25%2C-25%25)%3Bopacity%3A0%7D%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D%0A._1uo2Zfx2jY%7Bclip-path%3Ainset(0%20round%20var(--ds-radius-small%2C4px))%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._4eDJc6kO4Y%3Abefore%7Bbackground%3Aradial-gradient(circle%2028px%20at%2050%25%2050%25%2Chsla(0%2C0%25%2C100%25%2C.4)%200%2Ctransparent%20100%25)%2Cradial-gradient(circle%2028px%20at%2050%25%2050%25%2Chsla(0%2C0%25%2C100%25%2C.2)%200%2Chsla(0%2C0%25%2C100%25%2C.1)%2050%25%2Ctransparent%20100%25)%2Cradial-gradient(circle%2022px%20at%2055%25%2050%25%2Cvar(--ds-background-accent-orange-subtler%2C%23fce4a6)%200%2Ctransparent%20100%25)%2Cradial-gradient(circle%2028px%20at%2050%25%2055%25%2Cvar(--ds-background-accent-magenta-subtle%2C%23e774bb)%200%2Ctransparent%20100%25)%2Cradial-gradient(circle%2028px%20at%2050%25%2050%25%2Cvar(--ds-background-accent-purple-subtle%2C%23c97cf4)%200%2Ctransparent%20100%25)%2Cradial-gradient(circle%2028px%20at%2060%25%2055%25%2Cvar(--ds-background-accent-blue-subtle%2C%23669df1)%200%2Ctransparent%20100%25)%7D%0A._3fRV4C0oWv%3Abefore%7Bfilter%3Ablur(9pt)%7D%0A._1iAcE9M9iZ%3Abefore%7Banimation-duration%3A3s%7D%0A._0YTlbl7dHp%3Abefore%7Banimation-iteration-count%3A1%7D%0A._2ofBtgjkka%3Abefore%7Banimation-name%3Ak1y7llxx%7D%0A._2Il32FxxUt%3Abefore%7Bblock-size%3A200%25%7D%0A._3Ku51Iogpp%3Abefore%7Bcontent%3A%22%22%7D%0A._4odxdyN91d%3Abefore%7Binline-size%3A100%25%7D%0A._1cR5ZLLUVw%3Abefore%7Binset-block-start%3A-50%25%7D%0A._2jTvwtdnbC%3Abefore%7Binset-inline-start%3A0%7D%0A._2IjmTKdnbC%3Abefore%7Bopacity%3A0%7D%0A._0UsFEzYbGa%3Abefore%7Bpointer-events%3Anone%7D%0A._3dCYwDWVPG%3Abefore%7Bposition%3Aabsolute%7D%0A._3qT6l0dnbC%3Abefore%7Bz-index%3A0%7D%0A._0ubfYRjOvk%20button%7Bbackground-color%3Atransparent%7D%0A._0rushMjOvk%20button%3Ahover%7Bbackground-color%3Atransparent%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._4BbId5YbGa%3Abefore%7Banimation%3Anone%7D._4bHSExdnbC%3Abefore%7Bopacity%3A0%7D%7D%0A%40keyframes%20kb6d39w%7B0%25%7Bbox-shadow%3A0%200%200%202px%20var(--ds-border-discovery%2C%23af59e1)%2C0%200%200%20var(--ds-border-discovery%2C%23af59e1)%7D33%25%7Bbox-shadow%3A0%200%200%202px%20var(--ds-border-discovery%2C%23af59e1)%2C0%200%200%20var(--ds-border-discovery%2C%23af59e1)%7D66%25%7Bbox-shadow%3A0%200%200%202px%20var(--ds-border-discovery%2C%23af59e1)%2C0%200%200%2010px%20rgba(101%2C84%2C192%2C.01)%7Dto%7Bbox-shadow%3A0%200%200%202px%20var(--ds-border-discovery%2C%23af59e1)%2C0%200%200%2010px%20rgba(101%2C84%2C192%2C.01)%7D%7D%0A._0nFVCGM9iZ%7Banimation-duration%3A3s%7D%0A._03m2nySHWH%7Banimation-iteration-count%3Ainfinite%7D%0A._1gBibyAup0%7Banimation-name%3Akb6d39w%7D%0A._43vdfTs3G2%7Banimation-timing-function%3Acubic-bezier(.55%2C.055%2C.675%2C.19)%7D%0A._2OUyjtgbYL%7Bbox-shadow%3A0%200%200%202px%20var(--ds-border-discovery%2C%23af59e1)%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._39Ohv4YbGa%7Banimation%3Anone%7D._1SdfoHYbGa%7Btransition%3Anone%7D%7D");



































import { forwardRef, Fragment, Suspense, useCallback, useContext, useEffect, useRef, useState, type ForwardRefExoticComponent, type RefAttributes } from 'react';
import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';
import { mergeRefs } from 'use-callback-ref';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { PrimaryButton } from '@atlaskit/atlassian-navigation/primary-button';
import type { PrimaryButtonProps } from '@atlaskit/atlassian-navigation/primary-button/types';
import type { ButtonProps } from '@atlaskit/button/button';
import type { IconButtonProps } from '@atlaskit/button/icon/button';
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { RovoIcon } from '@atlaskit/logo/rovo/icon';
import { TopNavButton } from '@atlaskit/navigation-system/theming/top-nav-button';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { addRovoParamsToUrl } from '@atlaskit/rovo-triggers/params';
import { PopoverProvider } from '@atlaskit/spotlight/popover-provider';
import { PopoverTarget } from '@atlaskit/spotlight/popover-target';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import type { TooltipProps } from '@atlaskit/tooltip/types';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation/controllers/analytics';
import { usePostOfficeCoordination } from '@atlassian/conversation-assistant-onboarding/controllers/post-office-migration';
import { useConversationAssistantSpotlightActions, useConversationAssistantSpotlightState } from '@atlassian/conversation-assistant-onboarding/controllers/spotlight';
import { AsyncAtlasHomeFomoSpotlightPlacement } from '@atlassian/conversation-assistant-onboarding/ui/AtlasHomeFomoSpotlightAsync';
import { AsyncRovoFullPageSpotlightPlacement } from '@atlassian/conversation-assistant-onboarding/ui/RovoFullPageSpotlightAsync';
import { ConversationAssistantOnboardingSpotlight } from '@atlassian/conversation-assistant-onboarding/ui/Spotlight';
import { ProfileContext } from '@atlassian/conversation-assistant-store/controllers/profile';
import { usePostOfficePlacement } from '@atlassian/conversation-assistant-utils/usePostOfficePlacement';
import { useInsightsStatus } from '@atlassian/rovo-growth-pulse/services/insights-status';
import { ChunkErrorBoundary } from '../../common/ui/chunk-error-boundary/ChunkErrorBoundary';
import { ConditionalWrapper, type ConditionalWrapperChildren } from '../../common/ui/conditional-wrapper';
import { getDefaultShareBaseUrl } from '../share-conversation-modal/shareConversationUrl';
import { messages } from './messages';
import { prefetchPromptOfTheDay } from './prefetchPromptOfTheDay';
type Props = {
  testId?: string;
  isActive: boolean;
  isDisabled?: boolean;
  onClick: ButtonProps['onClick'];
  onMouseEnter?: React.MouseEventHandler<Element>;
  label?: React.ReactNode;
  tooltipContent?: React.ReactNode;
  shortcut?: TooltipProps['shortcut'];
  orgId?: string;
  siteId: string;
  productKey: string;
  analyticsAttributes?: Record<string, string | number | boolean | undefined>;
  /**
   * Opt in to the Post Office onboarding spotlight coordination flow.
   *
   * When omitted (the default) the button is pure and does not depend on Post Office, so it can be
   * rendered in surfaces that do not provide a `PostOfficeProvider` (for example the editor's Ask
   * Rovo floating toolbar). Only navigation surfaces that mount a Post Office provider and want the
   * agents-onboarding spotlight should set this to `true`.
   */
  enableOnboardingSpotlight?: boolean;
};
const defaultButtonStyles = {
  paddingInline: "var(--ds-space-100, 8px)"
};
const inactiveButtonStyles = {
  background: "var(--ds-background-neutral, #0515240F)"
};
const disabledButtonStyles = {
  background: "var(--ds-background-disabled, #0515240F)",
  color: "var(--ds-text-disabled, #080F214A)"
};
const conversationAssistantButtonWrapperNoOverlayStyles = null;
const topNavButtonFlareKeyframes = null;
const topNavButtonFlareAnimationStyles = null;
const baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #AF59E1)"}`;
const pulseKeyframes = null;
const pulseAnimationStyles = null;
const reduceMotionStyles = null;
const getAtlasChatUrl = (siteId: string, orgId?: string): string => {
  const orgPath = orgId ? `/o/${encodeURIComponent(orgId)}` : '';
  return addRovoParamsToUrl(`${getDefaultShareBaseUrl()}${orgPath}/chat?cloudId=${encodeURIComponent(siteId)}`, {
    cloudId: siteId,
    pathway: 'chat'
  });
};

/**
 * Wraps button in a div that plays the top-nav flare animation.
 */
const AnimatedFlareWrapper = ({
  productKey,
  children
}: {
  productKey: string;
  children: React.ReactNode;
}) => {
  const {
    sendAnalyticsEvent
  } = useAnalytics();
  useEffect(() => {
    sendAnalyticsEvent({
      eventType: 'ui',
      action: 'viewed',
      actionSubject: 'animation',
      actionSubjectId: 'conversationAssistantButtonFlareAnimation',
      attributes: {
        productKey
      }
    });
  }, [sendAnalyticsEvent, productKey]);
  return <div data-testid="animated-flare-wrapper" className={ax(["_0ubfYRlfZc _0RxVZVy7kJ _46PhP8f7mX _0rushMd1Zr _0jh4YZy7kJ", "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _3iDTPbccYA _1uo2Zfx2jY _1mT5xdRAKS _4eDJc6kO4Y _3fRV4C0oWv _1iAcE9M9iZ _0YTlbl7dHp _2ofBtgjkka _2Il32FxxUt _3Ku51Iogpp _4odxdyN91d _1cR5ZLLUVw _2jTvwtdnbC _2IjmTKdnbC _0UsFEzYbGa _3dCYwDWVPG _3qT6l0dnbC _0ubfYRjOvk _0rushMjOvk _4BbId5YbGa _4bHSExdnbC"])}>
			{children}
		</div>;
};
type ButtonComponentProps = {
  onMouseEnter?: React.MouseEventHandler;
  style?: React.CSSProperties;
  iconBefore?: React.ReactChild;
  testId?: string;
  isSelected?: boolean;
  onClick?: PrimaryButtonProps['onClick'];
  isDisabled?: boolean;
  tooltip?: React.ReactNode;
  shortcut?: TooltipProps['shortcut'];
  children: React.ReactNode;
  interactionName?: string;
};
type HTMLElementForwardedRefComponent = React.ForwardRefExoticComponent<ButtonComponentProps & React.RefAttributes<HTMLElement>>;
type HTMLButtonElementForwardedRefComponent = React.ForwardRefExoticComponent<ButtonComponentProps & React.RefAttributes<HTMLButtonElement>>;
const getConversationAssistantButton = (Button: HTMLButtonElementForwardedRefComponent | HTMLElementForwardedRefComponent = PrimaryButton) => forwardRef(({
  testId,
  isActive,
  isDisabled = false,
  onClick: onClickProp,
  onMouseEnter: onMouseEnterProp,
  label,
  tooltipContent,
  shortcut,
  orgId,
  siteId,
  productKey,
  analyticsAttributes,
  enableOnboardingSpotlight = false
}: Props, ref: React.Ref<HTMLButtonElement>) => {
  di(FeatureGates, useInsightsStatus);
  const {
    formatMessage
  } = useIntl();
  const {
    start
  } = useConversationAssistantSpotlightActions();
  const {
    PostOfficePlacement
  } = usePostOfficePlacement();
  // Read from context only: this must not trigger a profile request just by mounting.
  const profileAaid = useContext(ProfileContext)?.aaid;

  // Prefetch insights status to warm the cache before the user opens chat.
  // This triggers the backend to generate insights asynchronously if not already cached.
  // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
  const isPulseExperimentEnabled = FeatureGates.getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
  useInsightsStatus({
    enabled: isPulseExperimentEnabled,
    assistanceServiceParams: {
      touchpointSource: 'ask-rovo-button-prefetch',
      product: productKey,
      experienceId: 'ai-mate',
      siteId
    }
  });
  const [prefersReducedMotion] = useState(() => typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true);
  const [shouldShowMessage, setShouldShowMessage] = useState(false);
  const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
  const shouldUseCoordination = enableOnboardingSpotlight && !!messageId;
  const {
    sendAnalyticsEvent
  } = useAnalytics();

  // Capture initial prop values in a ref so the rendered event fires exactly once
  // on mount, even if reactive props like isActive/isDisabled change later.
  const renderedAttributesRef = useRef({
    isActive,
    isDisabled,
    productKey
  });
  const sendAnalyticsEventRef = useRef(sendAnalyticsEvent);
  sendAnalyticsEventRef.current = sendAnalyticsEvent;
  useEffect(() => {
    sendAnalyticsEventRef.current({
      eventType: 'operational',
      action: 'rendered',
      actionSubject: 'rovoChatButton',
      attributes: renderedAttributesRef.current
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const openRovoChat = (event: React.MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => {
    if (!isActive && onClick) {
      onClick(event, analyticsEvent);
    }
  };
  const onClick = useCallback<NonNullable<typeof onClickProp>>((...params) => {
    sendAnalyticsEvent({
      eventType: 'ui',
      action: 'clicked',
      actionSubject: 'rovoChatButton',
      attributes: {
        isActive,
        isDisabled,
        productKey,
        ...analyticsAttributes
      }
    });
    return onClickProp?.(...params);
  }, [analyticsAttributes, isActive, isDisabled, onClickProp, productKey, sendAnalyticsEvent]);
  const interactionName = isActive ? 'close-rovo-chat-nav-button' : 'open-rovo-chat-nav-button';
  const buttonLabel = label ?? formatMessage(messages.rovoChatButtonLabel);
  const getChildren = () => {
    const button = <Button data-spotlight-target="rovo-chat-ask-rovo-button" onMouseEnter={event => {
      onMouseEnterProp?.(event);
      // Fill the prompt-of-the-day cache before the panel opens, so it renders without a wait.
      void prefetchPromptOfTheDay(profileAaid);
      sendAnalyticsEvent({
        eventType: 'ui',
        action: 'hovered',
        actionSubject: 'rovoChatButton',
        attributes: {
          isActive,
          isDisabled,
          productKey
        }
      });
      if (shouldShowMessage) {
        sendAnalyticsEvent({
          eventType: 'ui',
          action: 'hovered',
          actionSubject: 'rovoChatButtonSpotlight'
        });
        start();
      }
    }} testId={testId} isSelected={isActive} onClick={onClick} isDisabled={isDisabled} tooltip={tooltipContent ?? <Fragment>{formatMessage(messages.rovoChatButtonLabel)}</Fragment>} shortcut={shortcut} style={{
      /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */
      ...defaultButtonStyles,
      ...(!isActive && inactiveButtonStyles),
      ...(isDisabled && disabledButtonStyles)
      /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */
    }}
    // The button's own visible/accessible label ("Ask Rovo") already conveys the
    // icon's meaning, so mark the icon as decorative to avoid a redundant
    // "Rovo Ask Rovo" screen reader announcement.
    iconBefore={<RovoIcon size="xxsmall" label="" />} interactionName={interactionName} ref={ref}>
						{buttonLabel}
					</Button>;
    if (Button === PrimaryButton) {
      return <div role="list">{button}</div>;
    }
    if (!isActive && !isDisabled) {
      const shouldAnimateTopNavButton = !prefersReducedMotion &&
      // Targets non-MAU Rovo Chat users — once a user becomes MAU, the gate
      // resolves to false on their next session (batch trait refreshes daily).
      fg('rovo_chat_non_mau_rovo_button_animation_filter') &&
      // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
      FeatureGates.getExperimentValue('ask_rovo_top_nav_button_animation', 'isEnabled', false);
      if (shouldAnimateTopNavButton) {
        return <AnimatedFlareWrapper productKey={productKey}>{button}</AnimatedFlareWrapper>;
      }
      return <div className={ax(["_0ubfYRlfZc _0RxVZVy7kJ _46PhP8f7mX _0rushMd1Zr _0jh4YZy7kJ"])}>{button}</div>;
    }
    return button;
  };

  // The long-running-task PostOffice placement is anchored to the Ask Rovo
  // button (via data-spotlight-target) and must mount for every product
  // including Townsquare (productKey="atlas"), so it lives outside
  // SpotlightWrapper which only renders for products that opt into the
  // agents-onboarding coordination flow.
  // Uses <Fragment> (not <>) because this file has @jsx pragma without @jsxFrag.
  // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
  const isFullPageSpotlightEnabled = productKey === 'jira' && FeatureGates.getExperimentValue('rovo_chat_full_page_chat_spotlight', 'isEnabled', false);
  // FOMO spotlight for Atlas home (townsquare).
  //
  // This is a plain killswitch, NOT an experiment read. Randomization and
  // exposure for `rovo_chat_fomo_spotlight_in_home` happen in exactly one
  // place: inside the spotlight's own eligibility gate, after the non-MAU
  // and has-collaborators checks (see AtlasHomeFomoSpotlightConsumer).
  // Reading the experiment here as well would assign every Atlas user who
  // renders this button — including Rovo Chat MAU users and users with no
  // collaborators, who can never see the spotlight — blending the
  // value-proof and social-proof arms into one indistinguishable cell.
  //
  // `rovo_chat_fomo_spotlight_lifecycle` is the message template's own
  // lifecycle gate (see the Post Office template's config.ts and
  // filters/index.ts). Reusing it keeps one switch for "is this message
  // live": when it is off Post Office would not deliver anyway, so this
  // check just avoids mounting the placement and its fetch.
  const isFomoSpotlightEnabled = productKey === 'atlas' && fg('rovo_chat_fomo_spotlight_lifecycle');
  return <Fragment>
					{shouldUseCoordination || isFullPageSpotlightEnabled || isFomoSpotlightEnabled ? <SpotlightWrapper setShouldShowMessage={setShouldShowMessage} messageId={messageId} orgId={orgId} siteId={siteId} children={getChildren()} shouldShowMessage={shouldShowMessage} openRovoChat={(event, analyticsEvent?) => openRovoChat(event, analyticsEvent!)} isFullPageSpotlightEnabled={isFullPageSpotlightEnabled} isFomoSpotlightEnabled={isFomoSpotlightEnabled} /> : getChildren()}
					{PostOfficePlacement && fg('rovo_chat_max_mode_spotlight') && <PostOfficePlacement placementId="rovo-chat-long-running-task-spotlight"
    // This placement fetches its own data. Disable the outer request to avoid duplicates
    // when React replays renders during Suspense retries.
    disableInitialData />}
				</Fragment>;
});
const Nav4Button = forwardRef(({
  tooltip,
  shortcut,
  ...props
}: ButtonComponentProps, forwardedRef: React.Ref<HTMLButtonElement>) => {
  return <Tooltip content={tooltip} shortcut={shortcut}
  // This button's visible text matches the tooltip
  // Announcing the tooltip means 'Chat' would be announced twice
  isScreenReaderAnnouncementDisabled>
				{({
      ref: tooltipRef,
      ...triggerProps
    }) => <TopNavButton interactionName={props?.interactionName} ref={mergeRefs([forwardedRef, tooltipRef])} {...triggerProps} {...props} onClick={(event, analyticsEvent) => {
      props.onClick?.(event, analyticsEvent);
      triggerProps.onClick?.(event);
    }} iconBefore={((() => props.iconBefore || null) as IconButtonProps['icon'])} />}
			</Tooltip>;
});
export const ConversationAssistantButton: ForwardRefExoticComponent<Props & RefAttributes<HTMLButtonElement>> = getConversationAssistantButton(PrimaryButton);
export const ConversationAssistantButtonNav4: ForwardRefExoticComponent<Props & RefAttributes<HTMLButtonElement>> = getConversationAssistantButton(Nav4Button);
export const SpotlightWrapper = ({
  children,
  messageId,
  orgId,
  siteId,
  setShouldShowMessage,
  shouldShowMessage,
  openRovoChat,
  isFullPageSpotlightEnabled = false,
  isFomoSpotlightEnabled = false
}: {
  children: ConditionalWrapperChildren;
  messageId: string;
  orgId?: string;
  siteId: string;
  setShouldShowMessage: React.Dispatch<React.SetStateAction<boolean>>;
  shouldShowMessage: boolean;
  openRovoChat: (event: React.MouseEvent<HTMLElement, MouseEvent>, analyticsEvent?: UIAnalyticsEvent) => void;
  isFullPageSpotlightEnabled?: boolean;
  isFomoSpotlightEnabled?: boolean;
}): JSX.Element => {
  di(usePostOfficeCoordination);
  const {
    activeSpotlight
  } = useConversationAssistantSpotlightState();
  const [onboardingStarted, stopOnboarding] = usePostOfficeCoordination(messageId);
  const {
    sendAnalyticsEvent
  } = useAnalytics();
  const onDismissMessage = () => {
    setShouldShowMessage(false);
    stopOnboarding();
  };
  const openFullPageRovoChat = useCallback(() => {
    window.location.assign(getAtlasChatUrl(siteId, orgId));
  }, [orgId, siteId]);
  useEffect(() => {
    if (shouldShowMessage && activeSpotlight !== null) {
      sendAnalyticsEvent({
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'rovoChatButtonSpotlight'
      });
    }
  }, [shouldShowMessage, activeSpotlight, sendAnalyticsEvent]);
  useEffect(() => {
    if (onboardingStarted) {
      setShouldShowMessage(true);
    }
  }, [onboardingStarted, setShouldShowMessage]);
  // Mutually exclusive with the onboarding spotlight — don't show both at once
  const shouldShowFullPageSpotlight = isFullPageSpotlightEnabled && !shouldShowMessage;
  const shouldShowFomoSpotlight = isFomoSpotlightEnabled && !shouldShowMessage;
  return <ConditionalWrapper condition={shouldShowMessage || shouldShowFullPageSpotlight || shouldShowFomoSpotlight} wrapper={children => <PopoverProvider>
					<PopoverTarget>
						<div className={ax([shouldShowMessage && activeSpotlight === null && "", shouldShowMessage && activeSpotlight === null && "_0bjKvDKxmn _0nFVCGM9iZ _03m2nySHWH _1gBibyAup0 _43vdfTs3G2 _2OUyjtgbYL", "_39Ohv4YbGa _1SdfoHYbGa"])}>
							{children}
							{shouldShowFullPageSpotlight && <ChunkErrorBoundary>
									<Suspense fallback={null}>
										<AsyncRovoFullPageSpotlightPlacement openRovoChat={openFullPageRovoChat} />
									</Suspense>
								</ChunkErrorBoundary>}
							{shouldShowFomoSpotlight && <ChunkErrorBoundary>
									<Suspense fallback={null}>
										<AsyncAtlasHomeFomoSpotlightPlacement />
									</Suspense>
								</ChunkErrorBoundary>}
						</div>
					</PopoverTarget>
					<ConversationAssistantOnboardingSpotlight onDismiss={onDismissMessage} openRovoChat={openRovoChat} />
				</PopoverProvider>}>
			{children}
		</ConditionalWrapper>;
};